import { Dispatch } from 'react';
import { request } from "./request";
import { SessionAction } from '../interfaces/Session';

export function postChild(dispatch: Dispatch<SessionAction>, id: string, body: any) {
  return request(dispatch, `/thicket/${id}/child`, {
    body,
    method: 'POST',
  });
}